module.exports = __webpack_public_path__ + "static/1-f4e4e0727282eaafce8672c3da38c3b0.jpg";